<template>
  <v-container fluid>
    <h1>
      Edit Territory {{ territory.territory_code }}
    </h1>

    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-text>
          <v-text-field v-model="form.territory_type"
                        label="Type">
          </v-text-field>

          <v-text-field v-model="form.region_id"
                        label="Region ID">
          </v-text-field>

          <v-text-field v-model="form.region_name"
                        label="Region Name">
          </v-text-field>

          <v-text-field v-model="form.district_id"
                        label="District ID">
          </v-text-field>

          <v-text-field v-model="form.district_name"
                        label="District Name">
          </v-text-field>

          <v-text-field v-model="form.territory_id"
                        label="Territory ID">
          </v-text-field>

          <v-text-field v-model="form.territory_external_id"
                        label="Territory External ID">
          </v-text-field>

          <v-text-field v-model="form.territory_code"
                        label="Territory Code">
          </v-text-field>

          <v-autocomplete v-model="form.users"
                          multiple
                          label="Users in this territory"
                          :items="users"
                          item-value="id"
                          :item-text="nameStatus"
                          chips
                          small-chips
                          deletable-chips
                          clearable>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 :disabled="form.busy"
                 color="primary">
            Update
          </v-btn>

          <v-btn :to="{name: 'admin.territories.index'}">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="deleteGroup"
                 color="error">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import {mapGetters} from 'vuex';
import territoryService from '../../services/territoryService';
import DOMPurify from 'dompurify';

export default {
  props: {
    territory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        region_id: this.territory.region_id,
        region_name: this.territory.region_name,
        district_id: this.territory.district_id,
        district_name: this.territory.district_name,
        territory_type: this.territory.territory_type,
        territory_id: this.territory.territory_id,
        territory_external_id: this.territory.territory_external_id,
        territory_code: this.territory.territory_code,
        territory_name: this.territory.territory_name,
        users: this.territory.users.map(u => u.id),
      })
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'team',
      'users',
    ])
  },
  created() {
    console.log('ShowTerritory.vue create()')
  },
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.put(`/api/territories/${this.territory.id}`)
        .then(response => {
          this.$toast.success('Territory updated.');
          this.$router.push({name: 'admin.territories.index'});
        })
    },
    nameStatus(user) {
      if (user.is_active) {
        return DOMPurify.sanitize(user.name);
      }
      return DOMPurify.sanitize(`${user.name} (INACTIVE)`);
    },
    deleteGroup() {
      if (confirm('Are you sure you want to delete this territory?')) {
        territoryService.deleteTerritory(this.territory.id)
          .then(() => {
            this.$toast.success('Territory deleted.');
            this.$router.replace({name: 'admin.territories.index'});
          })
      }
    }
  }
}
</script>
